import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { server } from "../../common";
import { shareurl } from "../../config";
import ShareModal from "../../ShareModal";
import { IoMdShare } from "react-icons/io";
import configContext from "../../context/configContext/configContext";

const NewsDetail = () => {
  document.title = "News";

  const { id } = useParams();
  const [news, setNews] = useState(null);
  const [showShareModal, setShowShareModal] = useState(false);
  const [sharedUrl, setSharedUrl] = useState("");
  const [sharedTitle, setSharedTitle] = useState("");
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);

  useEffect(() => {
    getIndustryNews();
    getyuvaNews();
  }, [id]);

  // Function to open the Share modal
  const openShareModal = (url, title) => {
    setSharedUrl(shareurl);
    setSharedTitle(title);
    setShowShareModal(true);
  };

  // Function to close the Share modal
  const closeShareModal = () => {
    setShowShareModal(false);
  };

  // YUVASARATHI
  const getyuvaNews = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get(`/news/getnews/${id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setNews(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // industry
  const getIndustryNews = () => {
    server
      .get(`/news/getind_news/${id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setNews(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  if (!news) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="container py-4 shadow p-4" style={{ marginTop: "1rem" }}>
        <div className="row">
          <div className="">
            <div className="row">
              <div className="col-md-8">
                <h3>{news.title}</h3>
              </div>
              <div className="col-md-4 text-end">
                <p className="text-end fs-3">
                  <IoMdShare onClick={() => openShareModal(news.title)} />
                </p>
              </div>
            </div>
            <div className="">
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <img src={news.image} className="d-block w-100" alt="..." />
                </div>
                <div className="carousel-item">
                  <img src={news.image} className="d-block w-100" alt="..." />
                </div>
                <div className="carousel-item">
                  <img src={news.image} className="d-block w-100" alt="..." />
                </div>
              </div>
            </div>
          </div>

          <div className="my-3">
            <h3 className="my-3">{news.title}</h3>
            <p>
              <b>Category:</b> {news.category}
            </p>
            <p>{news.description}</p>
          </div>
        </div>
      </div>

      <ShareModal
        showModal={showShareModal}
        handleClose={closeShareModal}
        url={`https://yuvasarathi.com/#/news/${id}`}
        title={sharedTitle}
      />
    </>
  );
};

export default NewsDetail;
